module.exports = __webpack_public_path__ + "img/20200613_135531.8e1e7209.jpg";